import "./incentive.scss"
import "./static/incentive-desktop.png"
import "./static/incentive-mobile.png"
import "./static/incentive-desktop.webp"
import "./static/incentive-mobile.webp"

import { showSignup } from "components/signup"
import { SESSION_RECORDING_EVENTS, sendSessionRecordingEvent } from "utils/session-recording"

declare global {
  interface Window {
    FCGON?: {
      logged_in?: boolean
    }
  }
}

function signupOptionsFor(form: HTMLFormElement) {
  const data = new FormData(form)
  const initialOffer = data.get("incentive_offer")
  const options: { initialOffer?: string; initialStep?: string } = {}

  if (typeof initialOffer === "string") {
    options.initialOffer = initialOffer
  }
  if (window.FCGON && window.FCGON.logged_in) {
    options.initialStep = "the-payment"
  }

  return options
}

function initIncentiveOffers(root: ParentNode = document) {
  const forms = Array.from(root.querySelectorAll<HTMLFormElement>(".js-incentive-offers"))

  forms.forEach((form) => {
    if (form.dataset.incentiveInitialized) return

    form.setAttribute("data-incentive-initialized", "true")
    form.addEventListener("submit", (event) => {
      event.preventDefault()
      showSignup(signupOptionsFor(form))
    })
  })
}

function sessionRecordingEventForIncentiveClick(target: EventTarget | null) {
  if (!(target instanceof Element)) return SESSION_RECORDING_EVENTS.incentivePanelClick
  if (target.closest(".incentive__submit")) {
    return SESSION_RECORDING_EVENTS.incentiveContinueClick
  }
  if (target.closest(".incentive__offer")) return SESSION_RECORDING_EVENTS.incentiveOfferClick

  return SESSION_RECORDING_EVENTS.incentivePanelClick
}

function initIncentiveSessionRecording(root: ParentNode = document) {
  const panels = Array.from(root.querySelectorAll<HTMLElement>(".incentive"))

  panels.forEach((panel) => {
    if (panel.dataset.sessionRecordingInitialized) return

    panel.setAttribute("data-session-recording-initialized", "true")
    panel.addEventListener("click", (event) => {
      sendSessionRecordingEvent(sessionRecordingEventForIncentiveClick(event.target))
    })
  })
}

function initIncentive(root: ParentNode = document) {
  initIncentiveOffers(root)
  initIncentiveSessionRecording(root)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initIncentive())
} else {
  initIncentive()
}
